import { TaskStates, TaskStatus } from "./constants";

export enum DownloadablePdfUrl {
  AUTO_INSURANCE_QUESTIONNAIRE = "https://earned-wealth-public-assets.s3.amazonaws.com/intake-pdf-forms/Earned_Auto_Insurance_Questionnaire.pdf",
  DISABILITY_INSURANCE_QUESTIONNAIRE = "https://earned-wealth-public-assets.s3.amazonaws.com/intake-pdf-forms/Earned_Disability_Insurance_Questionnaire.pdf",
  HOME_INSURANCE_QUESTIONNAIRE = "https://earned-wealth-public-assets.s3.amazonaws.com/intake-pdf-forms/Earned_Home_Insurance_Questionnaire.pdf",
  RISK_TOLERANCE_QUESTIONNAIRE = "https://earned-wealth-public-assets.s3.amazonaws.com/intake-pdf-forms/Earned_Risk_Tolerance_Questionnaire.pdf",
  MGP_QUESTIONNAIRE = "https://earned-wealth-public-assets.s3.amazonaws.com/intake-pdf-forms/Earned_Retirement_Lifestyle_Plan_Client.pdf",
  MGP_QUESTIONNAIRE_COCLIENT = "https://earned-wealth-public-assets.s3.amazonaws.com/intake-pdf-forms/Earned_Retirement_Lifestyle_Plan_CoClient.pdf",
  TERM_LIFE_INSURANCE_QUESTIONNAIRE = "https://earned-wealth-public-assets.s3.amazonaws.com/intake-pdf-forms/Earned_Term_Life_Insurance_Questionnaire.pdf",
  US_BANK_LINE_OF_CREDIT_INFO_QUESTIONNAIRE = "https://earned-wealth-public-assets.s3.amazonaws.com/intake-pdf-forms/Earned_US_Bank_Line_of_Credit_Info_Questionnaire.pdf",
}

export enum CTA {
  CLIENT_INTAKE_FORM = "client_intake_form",
  SCHEDULE_MEETING_ADVISOR = "schedule_meeting_advisor",
  CONNECT_INVESTMENT_ACCOUNT = "connect_investment_account",
  UPLOAD_BANKING_DOCUMENTS = "upload_banking_documents",
  UPLOAD_TAX_CENTER_DOCUMENT = "upload_tax_center_document",
  UPLOAD_TAX_DOCUMENTS = "upload_tax_documents",
  UPLOAD_CREDENTIALING_DOCUMENTS = "upload_credentialing_documents",
  UPLOAD_INVESTMENT_DOCUMENTS = "upload_investment_documents",
  DOCUSIGN_WMA = "docusign_wealth_management_agreement",
  DOCUSIGN_WDA = "docusign_wealth_diagnostic_agreement",
  DOCUSIGN_WMA_COCLIENT = "docusign_wealth_management_agreement_coclient",
  DOCUSIGN_WDA_COCLIENT = "docusign_wealth_diagnostic_agreement_coclient",
  FORM = "open_form",
  UPLOAD_INSURANCE_DOCUMENTS = "upload_insurance_documents",
  UPLOAD_TRUST_ESTATE_DOCUMENTS = "upload_trust_estate_documents",
  DOWNLOAD_PDF = "download_pdf",
  OPEN_WIZARD = "open_wizard",
  UPLOAD_GENERAL_DOCUMENTS = "upload_general_documents",
  OPEN_URL = "open_url",
  UPLOAD_INCOME_DOCUMENTS = "upload_income_documents",
  UPLOAD_REAL_ESTATE_DOCUMENTS = "upload_real_estate_documents",
  NAVIGATE_TO_TAX_CENTER = "navigate_to_tax_center",
}

export enum WizardId {
  DISABILITY_INSURANCE = "disability_insurance",
  TERM_LIFE_INSURANCE = "term_life_insurance",
  PROFILE = "profile",
  RISK_TOLERANCE = "risk_tolerance",
  MONEY_GUIDE_PRO = "money_guide_pro",
}

export interface TaskItemProps {
  id: string;
  title: string;
  description: string;
  createdBy: string;
  updatedBy: string;
  timestamp: Date;
  action?: string | null;
  isManual: boolean;
  status: TaskStates;
  options?: TaskStates[];
  templateId?: string;
  onAction: (id: string) => void;
  onEditItem: (id: string) => void;
  onCheck: (id: string) => void;
  showAdvisorButtons: boolean;
  onChangeTaskState?: (id: string, status: TaskStates) => void;
  onDeleteItem?: (id: string) => void;
}

export interface EnrichedTask extends Forme.Task {
  taskStates: Forme.TaskState[];
}

export interface MutateTaskState {
  taskId: string;
  state: TaskStates;
  animationDuration?: number;
}

export interface MutateTaskContext {
  previousMutatedTasksState: Forme.EnrichedTask[];
}

export interface RemoveTaskContext {
  previousTasks: Forme.EnrichedTask[];
}

export enum ProductTemplateId {
  WEALTH_DIAGNOSTIC = "wealthDiagnostic",
  WEALTH_MANAGEMENT = "wealthManagement",
}

// wizard ID's
// disability insurance

export enum ProductPhase {
  PHASE_1 = "PHASE_1",
  PHASE_2 = "PHASE_2",
}

export enum ProductTopic {
  FINANCIAL_PLAN = "Financial Plan",
  INVESTMENT_PLAN = "Investments",
  TAX_PLAN = "Tax Planning",
  TAX_CENTER = "Tax Center",
  CAREER = "Career Advisory",
  INSURANCE_PLAN = "Insurance",
  DEBT_AND_CASH = "Debt & Cash Management",
  ESTATE_PLAN = "Trust & Estate",
}

export enum TaskCategory {
  FINANCIAL_PLAN = "Financial Plan",
  INVESTMENT_PLAN = "Investments",
  TAX_PLAN = "Tax Planning",
  CAREER = "Career Advisory",
  INSURANCE_PLAN = "Insurance",
  DEBT_AND_CASH = "Debt & Cash Management",
  ESTATE_PLAN = "Trust & Estate",
  ONBOARDING = "Onboarding",
  PRE_ONBOARDING = "Pre-Onboarding",
  ONGOING_WEALTH_MANAGEMENT = "Ongoing Wealth Management",
}

export enum TaskTemplateId {
  COMPLETE_SELF_ASSESSMENT = "completeSelfAssessment",
  LINK_ACCOUNTS = "linkYourAccounts",
  LINK_ACCOUNTS_IN_PONTERA = "linkAccountsInPontera",
  MGP_QUESTIONNAIRE = "moneyGuideProQuestionnaire",
  MGP_QUESTIONNAIRE_COCLIENT = "moneyGuideProQuestionnaireWithCoClient",
  MGP_QUESTIONNAIRE_WIZARD = "moneyGuideProQuestionnaireWizard",
  REVIEW_WEALTH_DIAGNOSTIC_PLAN = "reviewWealthDiagnosticPlan",
  RISK_TOLERANCE_QUESTIONNAIRE = "riskToleranceQuestionnaire",
  RISK_TOLERANCE_QUESTIONNAIRE_COCLIENT = "riskToleranceQuestionnaireCoClient",
  SETUP_KICKOFF_ADVISORY_MEETING = "setupKickoffAdvisoryMeeting",
  SETUP_NEXT_ADVISORY_MEETING = "setupNextAdvisoryMeeting",
  SETUP_NEXT_ADVISORY_MEETING_ONGOING = "setupNextAdvisoryMeetingOngoing",
  SIGN_WEALTH_DIAGNOSTIC_AGREEMENT = "signWealthDiagnosticAgreement",
  SIGN_WEALTH_MANAGEMENT_AGREEMENT = "signWealthManagementAgreement",
  SIGN_WEALTH_DIAGNOSTIC_AGREEMENT_COCLIENT = "signWealthDiagnosticAgreementWithCoClient",
  SIGN_WEALTH_MANAGEMENT_AGREEMENT_COCLIENT = "signWealthManagementAgreementWithCoClient",
  UPDATE_AUTO_INSURANCE_INFORMATION = "updateAutoInsuranceInformation",
  UPDATE_CONTACT_INFORMATION = "updateContactInformation",
  UPDATE_DISABILITY_INSURANCE_INFORMATION = "updateDisabilityInsuranceInformation",
  UPDATE_DISABILITY_INSURANCE_INFORMATION_COCLIENT = "updateDisabilityInsuranceInformationCoClient",
  UPDATE_TERM_LIFE_INSURANCE_INFORMATION = "updateTermLifeInsuranceInformation",
  UPDATE_TERM_LIFE_INSURANCE_INFORMATION_COCLIENT = "updateTermLifeInsuranceInformationCoClient",
  UPDATE_HOME_INSURANCE_INFORMATION = "updateHomeInsuranceInformation",
  UPDATE_PERSONAL_INFORMATION = "updatePersonalInformation",
  UPDATE_PERSONAL_INFORMATION_COCLIENT = "updatePersonalInformationCoClient",
  UPGRADE_TO_WEALTH_MANAGEMENT = "upgradeToWealthManagement",
  UPLOAD_DISABILITY_INSURANCE_POLICY = "uploadDisabilityInsurancePolicy",
  UPLOAD_STUDENT_DEBT_STATEMENTS = "uploadStudentDebtStatements",
  UPLOAD_EMPLOYMENT_CONTRACT = "uploadEmploymentContract",
  UPLOAD_ESTATE_PLANNING_DOCUMENTS = "uploadEstatePlanningDocuments",
  UPLOAD_ILLIQUID_ASSET_INFORMATION = "uploadIlliquidAssetInformation",
  UPLOAD_INVESTMENT_STATEMENTS_PHASE_1 = "uploadInvestmentStatementsPhase1",
  UPLOAD_INVESTMENT_STATEMENTS = "uploadInvestmentStatements",
  UPLOAD_INSURANCE_POLICIES = "uploadInsurancePolicies",
  UPLOAD_PROPERTY_CASUALTY_INSURANCE_POLICY = "uploadPropertyCasualtyInsurancePolicy",
  UPLOAD_TAX_RETURNS = "uploadTaxReturns",
  UPLOAD_TAX_CENTER_DOCUMENT = "uploadTaxCenterDocument",
  UPLOAD_UMBRELLA_AND_LONG_TERM_CARE_INSURANCE_POLICIES = "uploadUmbrellaAndLongTermCareInsurancePolicies",
  UPLOAD_VOIDED_CHECK = "uploadVoidedCheck",
  WEALTHSCAPE_ACCOUNT_OPENING = "wealthscapeAccountOpening",
  TALK_TO_ADVISORY_TEAM_TO_BEGIN = "talkToAdvisoryTeamToBegin",
  SHARE_TAX_INFORMATION_WITH_YOUR_ADVISOR = "shareTaxInformationWithYourAdvisor",
  ANNUAL_CHECKUP_REVIEW = "annualCheckupReview",
  ANNUAL_CHECKUP_TAX_PREP_UPLOAD = "annualCheckupTaxPrepUpload",
  ANNUAL_CHECKUP_TAX_PLANNING_REVIEW = "annualCheckupTaxPlanningReview",
  UPLOAD_GOV_ISSUED_ID = "uploadGovIssuedId",
  UPLOAD_GOV_ISSUED_ID_COCLIENT = "uploadGovIssuedIdCoClient",
  SET_UP_ESTATE_PLAN_WITH_TRUST_WILL = "setUpEstatePlanWithTrustWill",
  UPLOAD_EMPLOYEE_BENEFITS_SUMMARY = "uploadEmployeeBenefitsSummary",
  UPLOAD_PAYSTUB = "uploadPaystub",
  UPLOAD_MORTGAGE_STATEMENT = "uploadMortgageStatement",
  UPLOAD_SOCIAL_SECURITY_STATEMENT = "uploadSocialSecurityStatement",
  UPLOAD_PROPERTY_TAX_STATEMENT = "uploadPropertyTaxStatement",
  NAVIGATE_TO_TAX_CENTER = "navigateToTaxCenter",
}
export interface TaskTemplate {
  name: string;
  description: string;
  callToAction?: CTA;
  templateId: TaskTemplateId;
  completeWithAdvisor?: boolean;
  estimatedCompletionTime?: number | null;
  productPhase: ProductPhase;
  productTopic?: ProductTopic;
  wealthDiagnostic: boolean;
  wealthManagement: boolean;
  downloadablePdfUrl?: string;
  sortIndex: number;
  isInitialTask: boolean;
  isCoClientTask?: boolean;
  isDocusignTask?: boolean;
  isPreOnboardingTask?: boolean;
  isOngoingWealthManagementTask?: boolean;
  ctaUrl?: string;
  ctaText?: string;
}

export interface EnrichedTaskTemplate extends TaskTemplate {
  id?: string;
  dueDate?: Date | null;
  createdAt?: Date;
  status?: TaskStatus;
  category: TaskCategory;
}
export interface TaskIdTemplateMap {
  [key: string]: string;
}

export interface TaskTemplateMap {
  [key: string]: EnrichedTaskTemplate[];
}

export interface MutateTaskInputs {
  taskName: string;
  templateId?: TaskTemplateId;
  productPhase: ProductPhase;
  productTopic?: ProductTopic;
  estimatedCompletionTime?: number | null;
  triggerNotification: boolean;
  description?: string;
  callToAction?: CTA;
  ctaUrl?: string;
  ctaText?: string;
  downloadablePdfUrl?: DownloadablePdfUrl;
  dueDate?: Date | null;
}

export interface UseWizardCloseConfirmProps {
  onConfirmClose?: () => void;
  dialogTitle?: string;
  dialogMessage?: string;
  backButtonText?: string;
  exitButtonText?: string;
}
